import script from "./PageSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSidebar.vue?vue&type=script&setup=true&lang=js"

import "./PageSidebar.vue?vue&type=style&index=0&id=700bdd71&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-700bdd71"]])

export default __exports__